import { graphql } from '@graphql/gql';

export const LOGOUT = graphql(`
  mutation LOGOUT($input: LogoutInput!) {
    logout(input: $input) {
      revokeStreamTokens
    }
  }
`);
